// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

/**
 * Supported Timezones enum.
 */
export enum TimeZoneEnum {
  UTC = 0,
  GMT = 1,
  GMT_m_12 = 2,
  GMT_m_11 = 3,
  GMT_m_10 = 4,
  GMT_m_09 = 5,
  GMT_m_08 = 6,
  GMT_m_07 = 7,
  GMT_m_06 = 8,
  GMT_m_05 = 9,
  GMT_m_04 = 10,
  GMT_m_03 = 11,
  GMT_m_02 = 12,
  GMT_m_01 = 13,
  GMT_p_01 = 14,
  GMT_p_02 = 15,
  GMT_p_03 = 16,
  GMT_p_04 = 17,
  GMT_p_05 = 18,
  GMT_p_06 = 19,
  GMT_p_07 = 20,
  GMT_p_08 = 21,
  GMT_p_09 = 22,
  GMT_p_10 = 23,
  GMT_p_11 = 24,
  GMT_p_12 = 25,
  GMT_p_13 = 26,
  GMT_p_14 = 27
}
